import React, { useEffect, useRef, useState } from "react";
import MobileLayout from "../MobileLayout";
import "./gameResult.css";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { getUserRank } from "../home-section/services";
import { useTranslation } from "react-i18next";
import analytics from "../analytics/track";
import { getMyResult, MyResult } from "../apis/BreefApis";
import { LevelCard } from "./LevelCard";
import { useCountUp } from "../lib/useCountUp";
import { useNavigate } from "react-router";
import BreefReportService from "./BreefReportService";

const GameResult = () => {
  const [t, i18n] = useTranslation("global");
  const [loading, setLoading] = useState(true);
  const smFname = useSelector((state: RootState) => state.onboard.firstname);
  const smLname = useSelector((state: RootState) => state.onboard.lastname);
  const smEmail = useSelector((state: RootState) => state.onboard.email);
  const smPhone = useSelector((state: RootState) => state.onboard.phone);
  const smUserID = useSelector((state: RootState) => state.onboard.userID);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">("success");
  const [breefCount, setBreefCount] = useState<number>(0);
  const totalScore = useRef<number>(0);
  const [isTracked, setIsTracked] = useState(false);
  const navigate = useNavigate();
  const newUser = useSelector((state: RootState) => state.onboard.newUser);
  const points = useSelector((state: RootState) => state.score.points);
  const duration = useSelector((state: RootState) => state.score.duration);
  const quizScore = useSelector((state: RootState) => state.score.quizScore);
  const sessionQuizScore = Number(sessionStorage.getItem("quizScore"));
  const gameScore = Number(sessionStorage.getItem("gameScore"));
  // The breef score as the server computed and saved it (game screen); the sum is only a fallback
  let savedResult: { breefScore?: number } = {};
  try {
    savedResult = JSON.parse(sessionStorage.getItem("gameResult") || "{}");
  } catch {
    savedResult = {};
  }
  // The server's result for this breef, total and level. The phone's own numbers are the fallback while it loads.
  const [mine, setMine] = useState<MyResult | null>(null);
  totalScore.current = mine?.thisBreef.submitted ? mine.thisBreef.breefScore : savedResult.breefScore ?? (quizScore || sessionQuizScore) + (points || gameScore);
  const shownScore = useCountUp(totalScore.current, !loading, 1100);
  useEffect(() => {
    if (!isTracked) {
      analytics.track("Dashboard Viewed", {
        current_page: "dashboard",
      });
      console.log("Dashboard Viewed");

      setIsTracked(true);
    }
    fetchTotalScoreById();
  }, [isTracked]);

  const fetchTotalScoreById = async () => {
    try {
      // The level comes from the participant's total across breefs, not from this breef alone; the server says
      // which level that is, with its heading, name and picture (admin → Levels)
      setMine(await getMyResult());
    } catch (error) {
      // The score of this breef is already known from the game screen - it is shown even if the total can't be read
      console.error("Error fetching total score:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleButtonClick = async () => {
      const access = sessionStorage.getItem("accessToken");
      // fetchData();
      const quizScoreLs: any = sessionStorage.getItem("quizScore");

      // The score was saved with the game round (the server computes it) - nothing to send from here
      try {
        const breefCountResponse: any = await BreefReportService.getBreefCountByUserId();
        setBreefCount((breefCountResponse && breefCountResponse.numberOfBreefsSubmitted) || 0);
      } catch (error) {
        console.log("Error in fetching breef count", error);
      }

      // setTimeout(async () => {
      //     navigate("/home");
      // }, 10000);

      console.log("snackbarMessage", snackbarMessage);
    };
    handleButtonClick();
  }, []);

  return (
    <MobileLayout>
      <div style={{
        display: "flex",
        flexDirection: "column",
        height: "100dvh",
        width: "100%",
        overflow: "hidden"
      }}>
        {!loading ? (
          <>
            <LevelCard level={mine?.level || null}>
              <p className="result-score">{shownScore.toLocaleString("da-DK")}</p>
              {mine && mine.total.breefsPlayed > 0 && (
                <p className="result-total">{t("gameResult.total", { score: mine.total.score.toLocaleString("da-DK"), count: mine.total.breefsPlayed })}</p>
              )}
            </LevelCard>
          </>
        ) : (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", fontFamily: "Roboto", color: "#666" }}>
            {t("gameResult.loading")}
          </div>
        )}
      </div>
    </MobileLayout>
  );
};

export default GameResult;